import { Component, Input, DoCheck, HostListener, OnInit } from '@angular/core';

import { BaseModalDirective } from '@app/components/modals/base-modal';

@Component({
    templateUrl: './health-plan-confirm.component.html',
    styleUrls: ['./health-plan-confirm.component.scss'],
    standalone: false
})
export class HealthPlanConfirmModalComponent extends BaseModalDirective implements DoCheck, OnInit {
  @Input() healthPlanDetails: any;
  screenWidth: number;
  screenHeight: number;
  isMobileView = false;
  mobileWidth = 480;
  
  ngOnInit() {
    this.getScreenSize(); // Initialize screen dimensions
  }
  
   @HostListener('window:resize')
  getScreenSize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }
  ngDoCheck() {
    this.isMobileView = this.screenWidth <= this.mobileWidth;
  }
}
